import React from 'react';
import { Box, Typography } from '@mui/material';
import { LuUser } from 'react-icons/lu';
import { elliottTokens as t } from './tokens';
import { messageBodySx } from './ElliottMessage';

// Admin's reply — right-aligned, brandy outline bubble, avatar on the right.
// Ported from the Elliott lesson redesign.
const LearnerMessage: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box sx={{ display: 'flex', gap: '14px', alignItems: 'flex-start', justifyContent: 'flex-end', pl: '40px' }}>
    <Box
      sx={{
        maxWidth: '100%',
        minWidth: 0,
        border: `2px solid ${t.brandLight}`,
        px: '14px',
        py: '10px',
        borderRadius: '8px 0 8px 8px' // square top-right, anchored to the avatar
      }}
    >
      <Typography sx={messageBodySx}>{children}</Typography>
    </Box>
    <Box
      sx={{
        flexShrink: 0,
        width: 36,
        height: 36,
        borderRadius: '50%',
        bgcolor: t.surface,
        border: `1px solid ${t.borderDim}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: t.textSecondary
      }}
    >
      <LuUser size={18} />
    </Box>
  </Box>
);

export default LearnerMessage;
